import { render, staticRenderFns } from "./PageRegistration.vue?vue&type=template&id=807c9002&scoped=true&"
import script from "./PageRegistration.vue?vue&type=script&lang=js&"
export * from "./PageRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PageRegistration.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PageRegistration.vue?vue&type=style&index=1&id=807c9002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807c9002",
  null
  
)

export default component.exports